import { VariableType } from '../../../../types/dashboard.types';

// Utility function to format values based on variable type
export const formatValue = (value: number, variableType: VariableType): string => {
  if (variableType === 'solar') {
    // For solar (kJ/m²), show as integer for values > 1000, otherwise 1 decimal
    return value >= 1000 ? value.toFixed(0) : value.toFixed(1);
  } else if (variableType === 'temperature') {
    return value.toFixed(1);
  } else {
    // Wind and other variables
    return value.toFixed(1);
  }
};

// Utility function to get precision for tooltip formatting
export const getTooltipPrecision = (value: number, variableType: VariableType): number => {
  if (variableType === 'temperature') {
    return 1;
  } else if (variableType === 'solar') {
    // For solar, use 0 decimals if value > 1000, otherwise 1 decimal
    return value >= 1000 ? 0 : 1;
  }
  return 2; // Default precision
};
